import { format, formatDistanceToNow, isValid, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * Data para o usuario, sempre em portugues do Brasil (CLAUDE.md, "Idioma").
 *
 * Toda data exibida passa por aqui. `toLocaleDateString()` cru depende da
 * configuracao do navegador de quem abre — a mesma tela mostraria `05/29/2026` para
 * uma pessoa e `29/05/2026` para outra, e num sistema de prestacao de contas isso
 * nao e detalhe.
 *
 * A ARMADILHA QUE ESTE ARQUIVO EXISTE PARA EVITAR: `new Date('2026-05-29')` e lido
 * como MEIA-NOITE EM UTC, e em Sao Paulo isso e 21h do dia 28. Uma validade de
 * documento apareceria um dia mais cedo, e um documento vencido apareceria vigente.
 * `paraData` ancora `YYYY-MM-DD` em meia-noite LOCAL, de proposito.
 */

type Entrada = Date | string | number | null | undefined;

/** O que aparece quando nao ha data. Travessao, nao campo vazio. */
const SEM_VALOR = '—';

function paraData(entrada: Entrada): Date | null {
  if (entrada == null || entrada === '') {
    return null;
  }
  if (entrada instanceof Date) {
    return isValid(entrada) ? entrada : null;
  }
  if (typeof entrada === 'number') {
    const data = new Date(entrada);
    return isValid(data) ? data : null;
  }

  const texto = entrada.trim();
  if (!texto) {
    return null;
  }

  // Data pura, sem hora: ancora local (ver o comentario do topo).
  if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) {
    const data = new Date(`${texto}T00:00:00`);
    return isValid(data) ? data : null;
  }
  // Competencia mensal: primeiro dia do mes.
  if (/^\d{4}-\d{2}$/.test(texto)) {
    const data = new Date(`${texto}-01T00:00:00`);
    return isValid(data) ? data : null;
  }

  const iso = parseISO(texto);
  if (isValid(iso)) {
    return iso;
  }
  const ultimoRecurso = new Date(texto);
  return isValid(ultimoRecurso) ? ultimoRecurso : null;
}

function formatar(entrada: Entrada, padrao: string, semValor = SEM_VALOR): string {
  const data = paraData(entrada);
  if (!data) {
    return semValor;
  }
  try {
    return format(data, padrao, { locale: ptBR });
  } catch {
    return semValor;
  }
}

/** `29/05/2026` */
export function formatarData(entrada: Entrada, semValor = SEM_VALOR): string {
  return formatar(entrada, 'dd/MM/yyyy', semValor);
}

/** `29/05/2026 14:32` */
export function formatarDataHora(entrada: Entrada, semValor = SEM_VALOR): string {
  return formatar(entrada, 'dd/MM/yyyy HH:mm', semValor);
}

/** `há 3 dias`, `há cerca de 2 horas`. */
export function formatarRelativo(entrada: Entrada, semValor = SEM_VALOR): string {
  const data = paraData(entrada);
  if (!data) {
    return semValor;
  }
  try {
    return formatDistanceToNow(data, { locale: ptBR, addSuffix: true });
  } catch {
    return semValor;
  }
}

/** `2026-05-29` — valor TECNICO, para parametro de API e chave de endereco. */
export function paraDataIso(entrada: Entrada): string | null {
  const data = paraData(entrada);
  return data ? format(data, 'yyyy-MM-dd') : null;
}
